enum AmplitudeEvent {
  ButtonClick = "button_click",
}

export default AmplitudeEvent;
